module.exports = __webpack_public_path__ + "img/header.0f68cf85.svg";